<section class="contact-top">
   
      <div class="inner_sec">
            <div class="container">
               <h2>Metal Machining.</h2>
            </div>
                 
            <div class="tabbing_sec">
                <mat-tab-group>
                    <mat-tab>
                      <ng-template mat-tab-label>

                    <div class="container"> 
                        <lucide-icon name="hammer" class="icon"></lucide-icon>
                        Capabilities
                    </div>
                      </ng-template>
                    
                      
             <div class="product_list">

              <div class="container">

                <div class="row column_one">    
                    <div class="col-sm-6">
                         <h3>Raw Materials</h3>
                         <ul class="top_list">
                            <li *ngFor="let data of rawmaterial"> 
                                <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.item}}
                            </li>
                        </ul>
                    </div>

                    <div class="col-sm-6">

                        <h3>Dimensions</h3>
                         <ul class="top_list">
                            <li *ngFor="let data of diamension"> 
                                <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.item}}
                            </li>
                        </ul>

                    </div>
                </div>

               </div>

                
                <div class="gray_sec light">

              <span class="icon_bg"> <img src="../../../../../assets/images/capability/blue/gray_bg.png"> </span>

              <div class="container">  

                <div class="row column_one">

                    <div class="col-sm-6">
                        <h3>Accuracies</h3>
                        <ul class="top_list">
                            <li *ngFor="let data of accuracy"> 
                                <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.item}}
                            </li>
                        </ul>
                    </div>
                    
                    <div class="col-sm-6">
                        <h3>Surface Treatments</h3>
                        <ul class="top_list">
                            <li *ngFor="let data of surfacetreatment"> 
                                <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.item}}
                            </li>
                        </ul>
                    </div>
 
               </div>   

              </div>
               
                </div>

                <div class="gray_sec light">

              <span class="icon_bg"> <img src="../../../../../assets/images/capability/blue/gray_bg.png">  </span>

              <div class="container"> 
                        
                <div class="product_box">
                            <!-- <h3>Advanced Moulding Techniques</h3> -->
                            <div class="row">   
                                <div class="col-sm-4" *ngFor="let data of advanceMoullding">
                                    <div class="productItem">
                                        <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                                        <p>{{data.title}}</p>
                                    </div>
                                </div>
                            </div>
                </div>

              </div>

                </div>    
                        
             </div>

                    </mat-tab>
                    <mat-tab>
                      <ng-template mat-tab-label>

                        <div class="container">
                           <lucide-icon name="PackageOpen" class="icon"></lucide-icon>
                            Products
                         </div>
                      </ng-template>
                      

                    <div class="container">

                      <div class="product_list">
                        <div class="product_box">
                           
                            <div class="row">   
                                <div class="col-sm-12">
                                    <div class="grid_box">
                                        <figure *ngFor="let data of produtimglist"> <img class="about-img" [src]="data.img" alt=""> </figure>
                                     </div>
                                     <ul class="top_list">
                                        <li *ngFor="let data of produtitemlist"> 
                                          <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.item}}
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                      </div>

                    </div>

                    <div class="product_list gray_sec">

                        <div class="container">
                        
                          <div class="product_box">
                            <div class="row">   
                                <div class="col-sm-12">
                                    <div class="grid_box">
                                        <figure *ngFor="let data of produtimglistone"> <img class="about-img" [src]="data.img" alt=""> </figure>
                                     </div>
                                     <ul class="top_list">
                                        <li *ngFor="let data of produtitemlistone"> 
                                          <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.item}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                           </div>

                       </div>
                
                    </div>

                    <div class="container">

                        <div class="product_list">
                          <div class="product_box">
                             
                              <div class="row">   
                                  <div class="col-sm-12">
                                      <div class="grid_box">
                                          <figure *ngFor="let data of produtimglisttwo"> <img class="about-img" [src]="data.img" alt=""> </figure>
                                       </div>
                                       <ul class="top_list">
                                          <li *ngFor="let data of produtitemlisttwo"> 
                                            <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.item}}
                                          </li>
                                      </ul>
                                  </div>
                              </div>
  
                          </div>
                        </div>
  
                      </div>

                    </mat-tab>
                  </mat-tab-group>
            </div>

      </div>

</section>
